<template>
    <div @click="pageClick">
        <img
                :id="image"
                class="page-image"
                :src="item.imageLink"
                :width="`100%`"
                :usemap="`#${mapName}`"
        />
        <map :name="mapName">
            <area
                    v-for="(vector, index) in item.vectors"
                    shape="poly"
                    :coords="getCoords(vector.poly)"
                    :key="index"
            />
        </map>
    </div>
</template>

<script>
    import * as $ from 'jquery'
    import 'maphilight'

    export default {
        name: 'page',

        props: [ 'item' ],

        data() {
            return {
                originalImage: {
                    width: null,
                    height: null
                },
                image: 'image' + this.item.pageNo
            }
        },

        created() {
            let image = new Image
            image.src = this.item.imageLink
            image.onload = () => {
                this.originalImage.width = image.width
                this.originalImage.height = image.height
            }
        },

        mounted() {
            $(document).ready(() => {
                $('#' + this.image).maphilight({
                    alwaysOn: true,
                    fillColor: "FF0000",
                    fillOpacity: 0.3,
                    stroke: false
                });
            });
        },

        methods: {
            getCoords(poly) {
                return `${this.calculate(poly.topLeft.x)}, ${this.calculate(poly.topLeft.y)}, ${this.calculate(poly.topRight.x)}, ${this.calculate(poly.topRight.y)}, ${this.calculate(poly.bottomRight.x)}, ${this.calculate(poly.bottomRight.y)}, ${this.calculate(poly.bottomLeft.x)}, ${this.calculate(poly.bottomLeft.y)}`
            },

            calculate(number) {
                const image = $('#' + this.image)
                const nWidth = image.width()
                const mul = number * nWidth
                return mul / this.originalImage.width
            },

            pageClick() {
                this.$emit("page-click", this.item.pageId);
            }
        },

        computed: {
            mapName() {
                return this.item.pageNo
            }
        }
    }
</script>

<style scoped>
    .page-image {
        margin: 0 auto;
    }
</style>
